/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import {
  Filter,
  TextInput,
  List,
  Datagrid,
  TextField,
  UrlField,
} from "react-admin";

import CustomActions from "../../../components/CustomActions";
import { ListPagination, downloadCsv } from "../../../utils";

const exporter = (data) => {
  const dataForExport = data.map((item) => ({
    Nome: item.name,
    URL: item.url,
    "Contrato Flash": item.externalId,
  }));

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: ["Nome", "URL", "Contrato Flash"], // order fields in the export
    },
    { delimiter: ";" }
  );

  downloadCsv(csv, "labs"); // download as 'posts.csv` file
};

const LabFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Nome" source="name" alwaysOn />
    {/* <TextInput label="Telefone" source="telephone" /> */}
    <TextInput label="URL" source="url" />
    <TextInput sortable={false} label="Grupo" source="groups.name" />
    <TextInput label="Contrato Flash" source="externalId" />
  </Filter>
);

const LabList = (props) => (
  <List
    hasCreate={true}
    perPage={25}
    title="Lista de Laboratórios"
    bulkActionButtons={<div />}
    actions={<CustomActions />}
    exporter={exporter}
    filters={<LabFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
    pagination={<ListPagination />}
    {...props}
  >
    <Datagrid rowClick="edit">
      <TextField label="Nome" source="name" />
      <TextField label="Grupo" sortable={false} source="group.name" />
      <UrlField label="URL" source="url" />
      <TextField label="Contrato Flash" source="externalId" />
    </Datagrid>
  </List>
);

export default LabList;
